import { SparklesIcon } from "@heroicons/react/20/solid";
import { useWizard } from "../../hooks/useWizard";

const ShowWIzardIcon = () => {
  const { setShowWizard, setFormValues } = useWizard();

  return (
    <div
      className="md:hidden lg:hidden xl:hidden absolute rounded shadow-md m-4 z-40 right-0"
      style={{ top: 56 }}
      onClick={() => {
        setFormValues({})
        setShowWizard(true)
      }}
    >
      <div className="rounded shadow-md bg-white">
        <div className="px-3 py-3">
          <SparklesIcon className="h-4 w-4" />
        </div>
      </div>
    </div>
  );
};

export default ShowWIzardIcon;
